<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 652 652"
    style="enable-background: new 0 0 100 100"
    :width="width"
    :height="height"
  >
    <g id="surface1">
      <path
        class="st0"
        d="M53.2,365.7c-12.4,0-21-10.4-21-23.9c0-13.6,8.6-23.9,21-23.9c12.4,0,21,10.4,21,23.9
			C74.2,355.3,65.8,365.7,53.2,365.7 M53.2,306.5c-17.3,0-33.2,14.8-33.2,35.3c0,20.5,15.9,35.3,33.2,35.3c17.4,0,33.2-14.8,33.2-35.3
			C86.4,321.3,70.5,306.5,53.2,306.5 M176.3,306.5c-10.6,0-17.4,5.9-21.2,11h-2.3c-4-5.7-10.2-11-19.4-11c-9.1,0-15.1,5.4-17.7,8.4
			h-1.9l-2.4-7.7h-8v69h12.2v-39.3c0-12.7,7.7-19.9,16.7-19.9c11.9,0,13.6,12.6,13.6,26v33.3H158v-40.3c0.4-12.1,8-18.9,16.7-18.9
			c11.9,0,13.6,12.6,13.6,26v33.3h12.2v-37.4C200.5,319.7,192.2,306.5,176.3,306.5 M252.8,306.5c-11.4,0-17.6,5.5-20.2,8.6h-1.7
			l-2.5-7.9h-8v69h12.1v-39.3c0-12.1,8.3-19.9,18.6-19.9c13.6,0,15.7,13.7,15.7,26v33.3h12.1v-37.4
			C278.9,319.6,270.3,306.5,252.8,306.5 M361.8,335.5c-6.8-1.8-13.3-4-13.3-10.4c0-5.7,5-9.3,11.3-9.3c7.3,0,12.7,4.7,12.7,9.8h11.2
			c0-9.5-8.4-19.6-23.9-19.6c-12.7,0-22.8,6.9-22.8,19.2c0,13.8,12.9,17.6,22.3,20.1c7.6,2.1,14.4,4.3,14.4,11.3c0,6.8-6.1,10-12.6,10
			c-7.6,0-14.9-4.4-14.9-13h-11.2c0,12.6,10.4,23,26.3,23c13.6,0,23.9-7.6,23.9-20.5C385.1,341.9,372.3,338.3,361.8,335.5
			M412.1,334.4c2.2-11.1,10-18.1,20.2-18.1c10.4,0,17.3,7.5,19,18.1H412.1L412.1,334.4z M432.5,306.1c-17.3,0-32.8,13.3-32.8,34.7
			c0,21.6,15.5,35.8,32.9,35.8c12.6,0,24.5-7.5,29.8-20.1h-12.7c-3.3,5.4-9.1,8.9-17,8.9c-11.9,0-19.9-8-21-20.9h52.3
			C465.3,318.4,449.1,306.1,432.5,306.1L432.5,306.1L432.5,306.1z M513.3,306.1c-11.4,0-17.6,5.5-20.2,8.6h-1.7l-2.5-7.9h-8v69h12.1
			v-39.3c0-12.1,8.3-19.9,18.6-19.9c13.6,0,15.7,13.7,15.7,26v33.3h12.1v-37.4C539.5,319.2,530.8,306.1,513.3,306.1 M588.5,365.3
			c-10.3,0-20.7-9-20.7-23.9c0-14.9,10.3-23.9,20.7-23.9c9.1,0,19.8,6.9,19.8,23.9C608.3,358.4,597.6,365.3,588.5,365.3L588.5,365.3
			L588.5,365.3z M608.3,277.8v39.4c-4.4-6.5-11.2-11-20.8-11c-17.5,0-31.8,14.8-31.8,35.2c0,20.4,14.3,35.2,31.8,35.2
			c9,0,15.4-3.9,19.7-9.5h2.2l2.6,8.8h8v-98.1H608.3L608.3,277.8z M294.3,295.3v10.5c9.5,2.8,11.1,12.7,11.1,25.6v44.8h12.1v-49
			C317.5,308.2,309.8,296.7,294.3,295.3 M308.6,265.4c-4.9,0-8.9,4-8.9,8.9c0,4.9,4,8.9,8.9,8.9c4.9,0,8.9-4,8.9-8.9
			C317.5,269.4,313.5,265.4,308.6,265.4"
      />
    </g>
  </svg>
</template>
<style type="text/css">
.st0 {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #555c66;
}
</style>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'OmnisendIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>
